import React, { useMemo } from "react"
import { useAppSelector } from "hooks"
import { selectSelectedActiveOrInactiveEmployeeDetails } from "store/Employee/detail.slice"
import { ConfigProvider, Statistic } from "antd-v5"
import useSchedulesQueryParams from "hooks/useSchedulesQueryParams"

const EmployeeTopBar: React.FC = () => {
	const { selectedEmployee = "" } = useSchedulesQueryParams()
	const selectedEmployeeDetails = useAppSelector(selectSelectedActiveOrInactiveEmployeeDetails(selectedEmployee))

	const data: { title: string; value: string | undefined; className?: string }[] = useMemo(() => {
		return [
			{ title: "PIN", value: selectedEmployeeDetails?.pin || "NA" },
			{ title: "App Username", value: selectedEmployeeDetails?.userName || "NA" },
			{ title: "First Name", value: selectedEmployeeDetails?.firstName || "NA" },
			{ title: "Last Name", value: selectedEmployeeDetails?.lastName || "NA" },
			{ title: "Short Name", value: selectedEmployeeDetails?.shortName || "NA" },
			{ title: "City", value: selectedEmployeeDetails?.city || "NA" },
			{ title: "Postal Code", value: selectedEmployeeDetails?.postalCode || "NA" },
			{ title: "Mobile", value: selectedEmployeeDetails?.mobile || "NA" },
			// { title: "Address Line 1", value: user?.addressLine1 },
			// { title: "Address Line 2", value: user?.addressLine2 },
			// { title: "Telephone", value: user?.telephone },
			// { title: "Email", value: user?.email },
			// { title: "County", value: user?.county?.name },
		]
	}, [selectedEmployeeDetails])

	return (
		<ConfigProvider
			prefixCls="ant5"
			theme={{
				components: {
					Statistic: {
						titleFontSize: 12,
						contentFontSize: 12,
						marginXXS: 0,
					},
				},
			}}
		>
			<div className="grid grid-cols-8">
				{data.map(({ title, value, className = "col-span-1" }) => (
					<Statistic
						key={title}
						title={title}
						value={value || "N/A"}
						className={className}
						formatter={val => val}
					/>
				))}
			</div>
		</ConfigProvider>
	)
}

export default EmployeeTopBar
